import { render, staticRenderFns } from "./SideNavLayout.vue?vue&type=template&id=8f0e2ea4&"
import script from "./SideNavLayout.vue?vue&type=script&lang=js&"
export * from "./SideNavLayout.vue?vue&type=script&lang=js&"
import style0 from "./SideNavLayout.vue?vue&type=style&index=0&id=8f0e2ea4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports